import { observer } from "mobx-react";
import { ShareIssuePerShareTypeModel } from "./increaseOfShareCapitalDomain";
import { RadioButtonGroup } from "@/components-v2/RadioButton";
import { identity } from "lodash";
import { useTranslation } from "@/stores/RootStoreContext";
import { Select } from "@/components-v2/Select";

export const FixedOrInterval = observer(function ({
  form,
  isLocked,
}: {
  form: ShareIssuePerShareTypeModel;
  isLocked: boolean;
}) {
  const { t } = useTranslation();
  return (
    <RadioButtonGroup
      name={"fixedOrInterval"}
      horizontal
      options={["fixed", "interval"]}
      idFn={identity}
      labelFn={(value) =>
        value === "fixed"
          ? t("decisions.increaseShareCapitalAgainstCash.newShares.isFixed.true")
          : t("decisions.increaseShareCapitalAgainstCash.newShares.isFixed.false")
      }
      onChange={(_, option) => form.changeIssueMode(option)}
      selected={form.issueMode.type}
      disabled={isLocked}
    />
  );
});

export const FixedOrInterval2 = observer(function ({
  form,
  isLocked,
}: {
  form: ShareIssuePerShareTypeModel;
  isLocked: boolean;
}) {
  const { t } = useTranslation();
  return (
    <Select
      name={"fixedOrInterval"}
      items={["fixed", "interval"]}
      idFn={identity}
      labelFn={(value) =>
        value === "fixed"
          ? t("decisions.increaseShareCapitalAgainstCash.newShares.isFixed.true")
          : t("decisions.increaseShareCapitalAgainstCash.newShares.isFixed.false")
      }
      onSelect={form.changeIssueMode}
      value={form.issueMode.type}
      disabled={isLocked}
    />
  );
});
